module.exports = __webpack_public_path__ + "img/icon-Social4.ab96c711.png";